import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useApi } from '../api';
import { formatearPrecio, abrirPdfAutenticado, formatearFechaLocal } from './utils';

// Material UI
import {
  Paper, Typography, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, IconButton,
  Tooltip, TextField, Dialog, DialogTitle, DialogContent,
  DialogActions, Button, CircularProgress, Box, Divider, Alert,
  Card, useMediaQuery, useTheme
} from '@mui/material';

// Iconos
import BuildIcon from '@mui/icons-material/Build';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import EditIcon from '@mui/icons-material/Edit';
import { motion } from 'framer-motion';

// Bootstrap Toast





const Facturacion = () => {
  const [ordenes, setOrdenes] = useState([]);
  const token = localStorage.getItem('token');
  const [generando, setGenerando] = useState(false);
  const [busqueda, setBusqueda] = useState('');
  const [facturas, setFacturas] = useState([]);
  const [fechaMin, setFechaMin] = useState('');
  const [fechaMax, setFechaMax] = useState('');
  const [facturaGenerada, setFacturaGenerada] = useState(null);
  const [mostrarConfirmacionIngreso, setMostrarConfirmacionIngreso] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [emailAdvertencia, setEmailAdvertencia] = useState(null);
  const [previa, setPrevia] = useState(null);
  const [mostrarPrevia, setMostrarPrevia] = useState(false);
  const [cargandoPrevia, setCargandoPrevia] = useState(false);
  const api = useApi();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));




  const [facturasFiltradas, setFacturasFiltradas] = useState(facturas);

  const navigate = useNavigate();

  const fetchFacturas = async () => {
    try {
      const params = new URLSearchParams();
      if (fechaMin) params.append('fecha_min', fechaMin);
      if (fechaMax) params.append('fecha_max', fechaMax);

      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/api/facturas/?${params.toString()}`
      
      );

      setFacturas(response.data.sort((a, b) => new Date(b.fecha) - new Date(a.fecha)));
    } catch (error) {
      console.error('Error al cargar facturas', error);
    }
  };

  const fetchOrdenes = async () => {
    try {
      const response = await api.get(`${process.env.REACT_APP_API_URL}/api/ordenes/?estado=completado`);
      setOrdenes(response.data);
    } catch (error) {
      console.error('Error al cargar órdenes completadas', error);
    }
  };

  useEffect(() => {
    fetchOrdenes();
    fetchFacturas();
  }, [refreshKey]);
  useEffect(() => {
    if (!busqueda) {
      setFacturasFiltradas(facturas);
    } else {
      const filtro = busqueda.toLowerCase();
      setFacturasFiltradas(
        facturas.filter(f =>
          (f.cliente && f.cliente.toLowerCase().includes(filtro)) ||
          (f.vehiculo && f.vehiculo.toLowerCase().includes(filtro))
        )
      );
    }
  }, [busqueda, facturas]);

const abrirPrevisualizacion = async (orden) => {
  setMostrarPrevia(true);
  setCargandoPrevia(true);
  try {
    const response = await api.get(`${process.env.REACT_APP_API_URL}/api/reparaciones/?orden=${orden.id}`);
    const reparaciones = response.data;
    const subtotal = reparaciones.reduce((acc, r) => acc + parseFloat(r.costo || 0), 0);
    const descuentoGarantia = reparaciones
      .filter(r => r.garantia)
      .reduce((acc, r) => acc + parseFloat(r.costo || 0), 0);
    const total = subtotal - descuentoGarantia;
    const abono = parseFloat(orden.abono || 0);
    const saldo = Math.max(total - abono, 0);
    setPrevia({ orden, reparaciones, subtotal, descuentoGarantia, total, abono, saldo });
  } catch (error) {
    console.error('Error al cargar la previsualización de la factura', error);
    alert('No se pudo cargar la previsualización de la factura.');
    setMostrarPrevia(false);
  } finally {
    setCargandoPrevia(false);
  }
};

const cerrarPrevisualizacion = () => {
  setMostrarPrevia(false);
  setPrevia(null);
};

const confirmarFacturacion = async () => {
  if (!previa) return;
  await generarFactura(previa.orden.id);
  setMostrarPrevia(false);
  setPrevia(null);
};

const generarFactura = async (ordenId) => {
  try {
    
    setGenerando(true);

    const response = await api.post(
      `${process.env.REACT_APP_API_URL}/api/facturas/`,
      { orden: ordenId }
      
    );
    setFacturaGenerada({
      orden: ordenId,
      total: response.data.total,
      consecutivo: response.data.consecutivo,
      prefijo: response.data.prefijo,
      pdf_url: response.data.pdf_url
    });
    if (response.data.email_advertencia) {
      setEmailAdvertencia(response.data.email_advertencia);
    }
    setMostrarConfirmacionIngreso(true);
    const pdfUrl = `${process.env.REACT_APP_API_URL}${response.data.pdf_url}`;
    //window.open(pdfUrl, '_blank');


    // Guardar la factura generada para luego registrar en ingresos

    
  } catch (error) {
    // Mismo manejo de errores que ya tenías
    setGenerando(false);

    if (error.response && error.response.data) {
      const { detail, pdf_url } = error.response.data;
      if (detail && pdf_url) {
        alert(detail);
        abrirPdfAutenticado(pdf_url, api);
        return;
      } else if (detail) {
        alert(detail);
        return;
      }
    }

    alert('Hubo un error al generar la factura');
    console.error('Error al generar factura', error);
  } finally {
    setGenerando(false);
  }
};


  const cerrarOrden = async (ordenId) => {
    try {
      await api.patch(`${process.env.REACT_APP_API_URL}/api/ordenes/${ordenId}/`, {
        estado: 'cerrada'
      });
      fetchOrdenes();
    } catch (error) {
      console.error('Error al cerrar la orden', error);
    }
  };



  return (
    <Paper sx={{ padding: 2 }}>
      {emailAdvertencia && (
        <Alert severity="warning" onClose={() => setEmailAdvertencia(null)} sx={{ mb: 3 }}>
          <strong>Advertencia de correo:</strong> {emailAdvertencia}
        </Alert>
      )}

      {/* Título principal animado */}
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
        <Typography className="titulo-app" variant="h5" gutterBottom>
          <ReceiptIcon sx={{ mr: 1, fontSize: 32, color: '#083a94', verticalAlign: 'middle' }} />
          Facturación
        </Typography>
      </motion.div>

      {/* Sección: Órdenes Completadas para Facturar */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.15, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
        <Paper elevation={2} sx={{ p: 2, mb: 3, borderLeft: '4px solid #083a94', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#083a94', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
            <BuildIcon sx={{ fontSize: 24 }} />
            Órdenes Completadas para Facturar
          </Typography>
          {isMobile ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {ordenes.map((orden) => (
                <Card key={orden.id} variant="outlined" sx={{ p: 2 }}>
                  <Typography sx={{ fontWeight: 700 }}>#{orden.id} · {orden.vehiculo}</Typography>
                  <Typography variant="body2" color="text.secondary">{orden.cliente}</Typography>
                  <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                    {new Date(orden.fecha_recepcion).toLocaleDateString()}
                  </Typography>
                  <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Ver las reparaciones de la orden">
                      <IconButton onClick={() => navigate(`/ordenes/${orden.id}/reparaciones?from=facturas`)} color="info">
                        <BuildIcon />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Ver previsualización y facturar">
                      <span>
                        <IconButton
                          onClick={() => abrirPrevisualizacion(orden)}
                          color="primary"
                          disabled={generando}
                        >
                          {generando ? (
                            <CircularProgress size={24} color="inherit" />
                          ) : (
                            <ReceiptIcon />
                          )}
                        </IconButton>
                      </span>
                    </Tooltip>
                  </Box>
                </Card>
              ))}
            </Box>
          ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Vehículo</TableCell>
                  <TableCell>Cliente</TableCell>
                  <TableCell>Fecha Recepción</TableCell>
                  <TableCell>Acciones</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ordenes.map((orden) => (
                  <TableRow key={orden.id}>
                    <TableCell>{orden.id}</TableCell>
                    <TableCell>{orden.vehiculo}</TableCell>
                    <TableCell>{orden.cliente}</TableCell>
                    <TableCell>{new Date(orden.fecha_recepcion).toLocaleDateString()}</TableCell>
                    <TableCell>
                      <Tooltip title="Ver las reparaciones de la orden">
                        <IconButton onClick={() => navigate(`/ordenes/${orden.id}/reparaciones?from=facturas`)} color="info">
                          <BuildIcon />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Ver previsualización y facturar">
                        <span>
                          <IconButton
                            onClick={() => abrirPrevisualizacion(orden)}
                            color="primary"
                            disabled={generando}
                          >
                            {generando ? (
                              <CircularProgress size={24} color="inherit" />
                            ) : (
                              <ReceiptIcon />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          )}
        </Paper>
      </motion.div>

      {/* Sección: Historial de Facturas */}
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, delay: 0.25, ease: [0.6, 0.01, 0.05, 0.95] }}
      >
        <Paper elevation={2} sx={{ p: 2, mb: 3, borderLeft: '4px solid #10b981', borderRadius: 2 }}>
          <Typography variant="h6" gutterBottom sx={{ color: '#065f46', fontWeight: 700, display: 'flex', alignItems: 'center', gap: 1 }}>
            <ReceiptLongIcon sx={{ fontSize: 24 }} />
            Historial de Facturas
          </Typography>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 2, mb: 2 }}>
            <TextField
              label="Buscar por Cliente o Placa"
              variant="outlined"
              size="small"
              value={busqueda}
              onChange={e => setBusqueda(e.target.value)}
              sx={{ width: 300 }}
            />
            <TextField
              label="Desde"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fechaMin}
              onChange={e => setFechaMin(e.target.value)}
            />
            <TextField
              label="Hasta"
              type="date"
              size="small"
              InputLabelProps={{ shrink: true }}
              value={fechaMax}
              onChange={e => setFechaMax(e.target.value)}
            />
            <Button variant="contained" onClick={fetchFacturas}>Buscar</Button>
          </Box>
          {isMobile ? (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
              {facturasFiltradas.map((factura) => (
                <Card key={factura.id} variant="outlined" sx={{ p: 2 }}>
                  <Typography sx={{ fontWeight: 700 }}>{factura.prefijo}{factura.consecutivo} · Orden #{factura.orden}</Typography>
                  <Typography variant="body2" color="text.secondary">{factura.cliente || '-'} · {factura.vehiculo || '-'}</Typography>
                  <Typography variant="body2" color="text.secondary">{new Date(factura.fecha).toLocaleDateString()}</Typography>
                  <Typography sx={{ fontWeight: 600, mt: 0.5, mb: 1.5 }}>${formatearPrecio(factura.total)}</Typography>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => abrirPdfAutenticado(factura.pdf, api)}
                  >
                    VER PDF
                  </Button>
                </Card>
              ))}
            </Box>
          ) : (
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell># Factura</TableCell>
                  <TableCell>Orden</TableCell>
                  <TableCell>Cliente</TableCell>
                  <TableCell>Vehículo</TableCell>
                  <TableCell>Fecha</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>PDF</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {facturasFiltradas.map((factura) => (
                  <TableRow key={factura.id}>
                    <TableCell>{factura.prefijo}{factura.consecutivo}</TableCell>
                    <TableCell>{factura.orden}</TableCell>
                    <TableCell>{factura.cliente || '-'}</TableCell>
                    <TableCell>{factura.vehiculo || '-'}</TableCell>
                    <TableCell>{new Date(factura.fecha).toLocaleDateString()}</TableCell>
                    <TableCell>${formatearPrecio(factura.total)}</TableCell>
                    <TableCell>
                      <Button
                        variant="outlined"
                        color="primary"
                        size="small"
                        onClick={() => abrirPdfAutenticado(factura.pdf, api)}
                      >
                        VER PDF
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          )}
        </Paper>
      </motion.div>

      {/* Vista previa de factura antes de enviar por correo */}
      <Dialog open={mostrarPrevia} onClose={cerrarPrevisualizacion} maxWidth="sm" fullWidth>
        <DialogTitle>
          Vista previa de factura{previa ? ` — Orden #${previa.orden.id}` : ''}
        </DialogTitle>
        <DialogContent>
          {cargandoPrevia || !previa ? (
            <Box display="flex" justifyContent="center" p={3}>
              <CircularProgress />
            </Box>
          ) : (
            <>
              <Typography variant="body2" sx={{ mb: 2 }}>
                Cliente: {previa.orden.cliente || '-'} &nbsp;|&nbsp; Vehículo: {previa.orden.vehiculo || '-'}
              </Typography>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Descripción</TableCell>
                    <TableCell align="right">Valor</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {previa.reparaciones.length === 0 ? (
                    <TableRow>
                      <TableCell colSpan={2}>No hay reparaciones registradas.</TableCell>
                    </TableRow>
                  ) : previa.reparaciones.map((r) => (
                    <TableRow key={r.id}>
                      <TableCell>{r.garantia ? `[Garantía] ${r.descripcion}` : r.descripcion}</TableCell>
                      <TableCell align="right">${formatearPrecio(r.costo)}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>

              <Divider sx={{ my: 2 }} />

              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography>Subtotal</Typography>
                <Typography>${formatearPrecio(previa.subtotal)}</Typography>
              </Box>
              {previa.descuentoGarantia > 0 && (
                <Box sx={{ display: 'flex', justifyContent: 'space-between', color: '#0a5e00' }}>
                  <Typography>Descuento garantía</Typography>
                  <Typography>-${formatearPrecio(previa.descuentoGarantia)}</Typography>
                </Box>
              )}
              <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                <Typography sx={{ fontWeight: 700 }}>Total</Typography>
                <Typography sx={{ fontWeight: 700 }}>${formatearPrecio(previa.total)}</Typography>
              </Box>
              {previa.abono > 0 && (
                <>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography>Abono recibido</Typography>
                    <Typography>-${formatearPrecio(previa.abono)}</Typography>
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Typography sx={{ fontWeight: 700 }}>Saldo pendiente</Typography>
                    <Typography sx={{ fontWeight: 700 }}>${formatearPrecio(previa.saldo)}</Typography>
                  </Box>
                </>
              )}
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={cerrarPrevisualizacion} disabled={generando}>Cancelar</Button>
          <Button
            startIcon={<EditIcon />}
            disabled={!previa || generando}
            onClick={() => {
              const ordenId = previa.orden.id;
              cerrarPrevisualizacion();
              navigate(`/ordenes/${ordenId}/reparaciones?from=facturas`);
            }}
          >
            Editar reparaciones
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={!previa || cargandoPrevia || generando}
            onClick={confirmarFacturacion}
          >
            {generando ? <CircularProgress size={20} color="inherit" /> : 'Confirmar Facturación'}
          </Button>
        </DialogActions>
      </Dialog>

  <Dialog open={mostrarConfirmacionIngreso} onClose={() => setMostrarConfirmacionIngreso(false)}>
    <DialogContent>
      <Typography>¿Desea registrar esta factura como ingreso en el módulo de finanzas?</Typography>
    </DialogContent>
    <DialogActions>
        <Button
          onClick={() => {
            setMostrarConfirmacionIngreso(false);
            
            setFacturaGenerada(null); // Limpiar
            setRefreshKey(prev => prev + 1); 
            setTimeout(() => {
              if (facturaGenerada?.pdf_url) {
                abrirPdfAutenticado(facturaGenerada.pdf_url, api);
              }
            }, 500); // Pequeño retraso para que el efecto visual se complete
          }}
          color="error"
        >
          No, solo generar factura
        </Button>


      <Button
        onClick={async () => {
          try {
            await api.post(
              `${process.env.REACT_APP_API_URL}/api/ingresos-gastos/`,
              {
                descripcion: `Factura ${facturaGenerada.prefijo}${facturaGenerada.consecutivo} - Orden #${facturaGenerada.orden}`,
                tipo: 'Ingreso',
                monto: facturaGenerada.total,
                fecha: formatearFechaLocal(),
              }
            );
          } catch (err) {
            console.error('Error al registrar ingreso', err);
          } finally {
            setMostrarConfirmacionIngreso(false);
            
            setFacturaGenerada(null); // Limpiar
            setRefreshKey(prev => prev + 1); 

            setTimeout(() => {
              if (facturaGenerada?.pdf_url) {
                abrirPdfAutenticado(facturaGenerada.pdf_url, api);
              }
            }, 500);
          }
        }}
        color="success"
      >
        Sí, registrar ingreso
      </Button>


    </DialogActions>
  </Dialog>


    </Paper>

    
  );
};

export default Facturacion;
